import React from 'react';
import { Box, Typography, Checkbox, IconButton } from '@mui/material';

import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';

export function getPeriod(id) {
    return id === 1 ? 'H1' : id === 2 ? 'H2' : 'OT';
}

const GameTagListItem = ({ item, isSelected, idx, isChecked, onChecked, onShowVideo, onChangeTime }) => {
    const startTime = item.team_tag_start_time || item.player_tag_start_time || '';
    const endTime = item.team_tag_end_time || item.player_tag_end_time || '';

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer',
                padding: '12px 16px',
                justifyContent: 'space-between',
                backgroundColor: isSelected ? '#f5f3ff' : '#ffffff',
                borderLeft: isSelected ? '4px solid #6366f1' : '4px solid transparent',
                transition: 'all 0.15s ease',
                '&:hover': {
                    backgroundColor: isSelected ? '#f5f3ff' : '#f9fafb'
                }
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px', flex: 1 }} onClick={() => onShowVideo(idx)}>
                <Box
                    sx={{
                        background: isSelected ? '#6366f1' : '#e5e7eb',
                        borderRadius: '8px',
                        width: '36px',
                        height: '36px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0
                    }}
                >
                    <Typography sx={{ color: isSelected ? '#ffffff' : '#6b7280', fontWeight: 600, fontSize: '14px' }}>
                        {idx + 1}
                    </Typography>
                </Box>

                <Box sx={{ display: 'flex', flexDirection: 'column', gap: '2px', flex: 1, minWidth: 0 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                        <Box
                            sx={{
                                backgroundColor: '#dbeafe',
                                color: '#1d4ed8',
                                padding: '2px 8px',
                                borderRadius: '4px',
                                fontSize: '11px',
                                fontWeight: 600
                            }}
                        >
                            {getPeriod(item.period)} - {item.time_in_game}'
                        </Box>
                        <Typography
                            sx={{
                                fontSize: '14px',
                                fontWeight: 500,
                                color: '#1f2937',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            {item.player_names}
                        </Typography>
                    </Box>
                    <Typography
                        sx={{
                            fontSize: '13px',
                            color: '#6b7280',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                        }}
                    >
                        {[item.action_names, item.action_type_names, item.action_result_names].filter(Boolean).join(' - ')}
                    </Typography>
                    {item.home_team_name && item.away_team_name && (
                        <Typography sx={{ fontSize: '12px', color: '#9ca3af' }}>
                            {item.home_team_name} vs {item.away_team_name}
                        </Typography>
                    )}
                </Box>

                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: 32,
                        height: 32,
                        borderRadius: '50%',
                        backgroundColor: isSelected ? '#6366f1' : '#f3f4f6',
                        flexShrink: 0,
                        '&:hover': { backgroundColor: isSelected ? '#4f46e5' : '#e5e7eb' }
                    }}
                >
                    <PlayArrowIcon sx={{ color: isSelected ? '#ffffff' : '#6b7280', fontSize: 18 }} />
                </Box>
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: '16px', marginLeft: '16px' }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px', minWidth: '120px' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <IconButton
                            size="small"
                            onClick={(e) => { e.stopPropagation(); onChangeTime(idx, true, -5); }}
                            sx={{ padding: '2px', color: '#9ca3af', '&:hover': { color: '#6366f1' } }}
                        >
                            <RemoveIcon sx={{ fontSize: 16 }} />
                        </IconButton>
                        <Typography sx={{ fontSize: '12px', color: '#6b7280', fontFamily: 'monospace' }}>
                            {startTime}
                        </Typography>
                        <IconButton
                            size="small"
                            onClick={(e) => { e.stopPropagation(); onChangeTime(idx, true, 5); }}
                            sx={{ padding: '2px', color: '#9ca3af', '&:hover': { color: '#6366f1' } }}
                        >
                            <AddIcon sx={{ fontSize: 16 }} />
                        </IconButton>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <IconButton
                            size="small"
                            onClick={(e) => { e.stopPropagation(); onChangeTime(idx, false, -5); }}
                            sx={{ padding: '2px', color: '#9ca3af', '&:hover': { color: '#6366f1' } }}
                        >
                            <RemoveIcon sx={{ fontSize: 16 }} />
                        </IconButton>
                        <Typography sx={{ fontSize: '12px', color: '#6b7280', fontFamily: 'monospace' }}>
                            {endTime}
                        </Typography>
                        <IconButton
                            size="small"
                            onClick={(e) => { e.stopPropagation(); onChangeTime(idx, false, 5); }}
                            sx={{ padding: '2px', color: '#9ca3af', '&:hover': { color: '#6366f1' } }}
                        >
                            <AddIcon sx={{ fontSize: 16 }} />
                        </IconButton>
                    </Box>
                </Box>

                <Checkbox
                    checked={!!isChecked}
                    onChange={onChecked(idx)}
                    onClick={(e) => e.stopPropagation()}
                    sx={{
                        color: '#d1d5db',
                        '&.Mui-checked': { color: '#6366f1' }
                    }}
                />
            </Box>
        </Box>
    );
};

export default GameTagListItem;
